/**
 * Mature-content flag (X7 / CAT-4): the reserved tag `mature` in `sounds.tags`.
 * A flagged row stays active and its detail page works; the flag keeps it off
 * default and prominent surfaces. A tag needs no migration, and nothing changes
 * until a row carries it. Every filter keeps NULL tags: `NOT (NULL @> ...)` is
 * NULL in SQL and would drop untagged rows.
 *
 * Flag a row with:
 * update sounds set tags = array_append(coalesce(tags, '{}'), 'mature')
 * where id = '<uuid>' and not (coalesce(tags, '{}') @> '{mature}')
 */

import type { Sound } from './supabase-types'

export const MATURE_TAG = 'mature'

/** PostgREST `or=` body that keeps every row NOT flagged mature (NULL tags included). */
export const EXCLUDE_MATURE_FILTER = `tags.is.null,tags.not.cs.{${MATURE_TAG}}`

type TaggedSound = Pick<Sound, 'tags'>

export function isMatureSound(sound: TaggedSound | null | undefined): boolean {
  return Boolean(sound?.tags?.includes(MATURE_TAG))
}

/** Drops flagged rows from an already-fetched list. */
export function withoutMature<T extends TaggedSound>(sounds: readonly T[]): T[] {
  return sounds.filter(sound => !isMatureSound(sound))
}

/** The flag is bookkeeping, not a topic: keep it out of tag chips and keywords. */
export function visibleTags(tags: readonly string[] | null | undefined): string[] {
  return (tags ?? []).filter(tag => tag !== MATURE_TAG)
}

/** Detail-page label. Plain statement of what the visitor will hear. */
export const MATURE_LABEL_DETAIL = 'Contains strong language.'
